import type { BloomUniversalHubFields } from '../types/bloomUniversalContent';
import fallbackJson from './bloomUniversalContent.fallback.json';

/**
 * Offline / Contentful-error fallback — copy + structure only.
 * Images and icons come from Contentful; this JSON has no local media URLs.
 * App SVGs cover chrome icons (arrow, phone, breadcrumb) when CMS icons are absent.
 */
export const BLOOM_UNIVERSAL_HUB_FALLBACK =
  fallbackJson as BloomUniversalHubFields;
